import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Widget } from '@cms/interfaces/widget';
import BpcWidgetDetails from '@cms/components/details/widget-details/widget-details.vue';
import WidgetContactForm from '@cms/components/forms/widget-contact-form.vue';

@Component({
  name: 'bpc-widget-list',
  components: {
    'bpc-widget-details': BpcWidgetDetails,
    'bpc-widget-contact-form': WidgetContactForm,
  },
})
export default class WidgetList extends Vue {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly widgets: Widget[];
}
